<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router';

import { logoTitle } from '@/utils/PortalConstants';
import SideBarBigLogoImg from '@/components/imgs/SideBarBigLogoImg.vue';
import SideBarSmallLogoImg from '@/components/imgs/SideBarSmallLogoImg.vue';

export interface Props {
  isMini?: boolean;
  to?: RouteLocationRaw;
}
const props = withDefaults(defineProps<Props>(), {
  isMini: false,
  to: '/',
});
</script>

<template>
  <router-link
    :to="props.to"
    :class="[$style.logoImgLink, { [$style.isMini]: props.isMini }]"
    :title="logoTitle"
    data-testid="logoImgLink"
  >
    <SideBarSmallLogoImg v-if="props.isMini" :class="$style.img" />
    <SideBarBigLogoImg v-else :class="$style.img" />
  </router-link>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.logoImgLink {
  display: inline-block;
}
  .img {
    display: block;
  }
</style>
